(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('content-tabs')) {
  class ContentTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[role="tabpanel"]');
        if (!panel) return;
        const index = this.panels.indexOf(panel);
        if (index > -1) this.select(index);
      });

      this.syncVideos();
    }

    onKeydown(event, index) {
      const rtl = document.documentElement.getAttribute('dir') === 'rtl';
      const last = this.tabs.length - 1;
      let next = null;

      if (event.key === 'ArrowRight') next = rtl ? index - 1 : index + 1;
      else if (event.key === 'ArrowLeft') next = rtl ? index + 1 : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      else return;

      event.preventDefault();
      if (next < 0) next = last;
      if (next > last) next = 0;
      this.select(next, true);
    }

    select(index, focus) {
      if (!this.tabs[index]) return;

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      this.syncVideos();
      if (focus) this.tabs[index].focus();
    }

    syncVideos() {
      this.panels.forEach((panel) => {
        const active = !panel.hidden;
        panel.querySelectorAll('video').forEach((video) => {
          const autoplay = video.classList.contains('content-tabs__video--autoplay');
          if (active && autoplay && !this.reduceMotion) {
            this.playVideo(video);
          } else {
            video.pause();
            if (autoplay && this.reduceMotion) video.controls = true;
          }
        });
      });
    }

    playVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const start = () => {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            video.controls = true;
          });
        }
      };

      const kick = () => {
        if (video.readyState >= 2) start();
        else {
          video.addEventListener('canplay', start, { once: true });
          if (video.readyState === 0) video.load();
        }
      };

      requestAnimationFrame(kick);
    }
  }

  customElements.define('content-tabs', ContentTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmetologists"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(s) {
      try {
        return String(s || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      } catch (e) {
        return String(s || '').toLowerCase();
      }
    }

    function digits(s) {
      return String(s || '').replace(/\D/g, '');
    }

    function cardMatches(card, q, mode) {
      if (!q) return true;
      var nq = norm(q);
      var qd = digits(q);
      var n = norm(card.getAttribute('data-cos-name') || '');
      var a = norm(card.getAttribute('data-cos-address') || '');
      var c = norm(card.getAttribute('data-cos-city') || '');
      var p = card.getAttribute('data-cos-phone') || '';
      var pd = digits(p);
      var pn = norm(p);
      if (mode === 'name') return n.indexOf(nq) !== -1;
      if (mode === 'address') return a.indexOf(nq) !== -1;
      if (mode === 'city') return c.indexOf(nq) !== -1;
      if (mode === 'phone') return (qd && pd.indexOf(qd) !== -1) || pn.indexOf(nq) !== -1;
      return (
        n.indexOf(nq) !== -1 ||
        a.indexOf(nq) !== -1 ||
        c.indexOf(nq) !== -1 ||
        (qd && pd.indexOf(qd) !== -1) ||
        pn.indexOf(nq) !== -1
      );
    }

    function cardMatchesAll(card, rules) {
      for (var r = 0; r < rules.length; r++) {
        if (!cardMatches(card, rules[r].q, rules[r].mode)) return false;
      }
      return true;
    }

    var COS_SAMPLE_SIZE = 3;

    function collectRules(dir) {
      var inputs = dir.querySelectorAll('[data-cos-filter-input]');
      var rules = [];
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (!inp.hasAttribute('data-cos-applied')) continue;
        var q = inp.getAttribute('data-cos-applied');
        if (q === null || q === '') continue;
        q = String(q).trim();
        if (!q) continue;
        rules.push({
          q: q,
          mode: inp.getAttribute('data-cos-filter-mode') || 'name',
        });
      }
      return rules;
    }

    function hasCityRule(rules) {
      for (var r = 0; r < rules.length; r++) {
        if (rules[r].mode === 'city' && rules[r].q) return true;
      }
      return false;
    }

    function getMatchingCards(cards, rules) {
      var matched = [];
      for (var i = 0; i < cards.length; i++) {
        if (cardMatchesAll(cards[i], rules)) matched.push(cards[i]);
      }
      return matched;
    }

    function shuffleInPlace(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      return arr;
    }

    function hideAllCards(cards) {
      for (var i = 0; i < cards.length; i++) cards[i].hidden = true;
    }

    function getVisibleCards(cards) {
      var visible = [];
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].hidden) visible.push(cards[i]);
      }
      return visible;
    }

    function showRandomFromPool(allCards, pool, preferDifferent, excludeCards) {
      hideAllCards(allCards);
      if (!pool.length) return 0;
      var limit = Math.min(COS_SAMPLE_SIZE, pool.length);
      var pickPool = pool.slice();
      if (preferDifferent && excludeCards && excludeCards.length && pool.length > limit) {
        var alt = [];
        for (var i = 0; i < pickPool.length; i++) {
          if (excludeCards.indexOf(pickPool[i]) === -1) alt.push(pickPool[i]);
        }
        if (alt.length >= limit) pickPool = alt;
      }
      shuffleInPlace(pickPool);
      var picked = pickPool.slice(0, limit);
      for (var p = 0; p < picked.length; p++) picked[p].hidden = false;
      return picked.length;
    }

    function setResultsStatus(dir, rules, shownCount, totalCount) {
      var head = dir.querySelector('[data-cos-results-head]');
      var statusEl = dir.querySelector('[data-cos-results-status]');
      var statusTpl = '__COUNT__ תוצאות עבור __TERMS__';
      var cityStatusTpl = 'מציג __SHOWN__ מתוך __TOTAL__ עבור __TERMS__';
      if (head) head.hidden = false;
      if (!statusEl) return;
      var terms = rules
        .map(function (r) {
          return r.q;
        })
        .join(', ');
      if (hasCityRule(rules) && totalCount > shownCount) {
        statusEl.textContent = cityStatusTpl
          .replace(/__SHOWN__/g, String(shownCount))
          .replace(/__TOTAL__/g, String(totalCount))
          .replace(/__TERMS__/g, terms);
      } else {
        statusEl.textContent = statusTpl.replace(/__COUNT__/g, String(shownCount)).replace(/__TERMS__/g, terms);
      }
    }

    function applyCitySample(dir, cards, rules, preferDifferent, excludeCards) {
      var shuffleWrap = dir.querySelector('[data-cos-shuffle-wrap]');
      var matched = getMatchingCards(cards, rules);
      var shown = showRandomFromPool(cards, matched, preferDifferent, excludeCards);
      setResultsStatus(dir, rules, shown, matched.length);
      if (shuffleWrap) shuffleWrap.hidden = matched.length <= COS_SAMPLE_SIZE;
    }

    function clearResults(dir, cards) {
      var head = dir.querySelector('[data-cos-results-head]');
      var statusEl = dir.querySelector('[data-cos-results-status]');
      var shuffleWrap = dir.querySelector('[data-cos-shuffle-wrap]');
      hideAllCards(cards);
      if (head) head.hidden = true;
      if (statusEl) statusEl.textContent = '';
      if (shuffleWrap) shuffleWrap.hidden = true;
    }

    function apply(dir) {
      var rules = collectRules(dir);
      var wrap = dir.querySelector('[data-cos-shared-results]');
      var shuffleWrap = dir.querySelector('[data-cos-shuffle-wrap]');
      var cards = wrap ? wrap.querySelectorAll('.cosmetologist-card') : [];
      var i;

      if (rules.length === 0) {
        clearResults(dir, cards);
        return;
      }

      if (hasCityRule(rules)) {
        applyCitySample(dir, cards, rules, false, null);
        return;
      }

      if (shuffleWrap) shuffleWrap.hidden = true;
      var head = dir.querySelector('[data-cos-results-head]');
      var statusEl = dir.querySelector('[data-cos-results-status]');
      var statusTpl = '__COUNT__ תוצאות עבור __TERMS__';
      var visible = 0;
      for (i = 0; i < cards.length; i++) {
        var ok = cardMatchesAll(cards[i], rules);
        cards[i].hidden = !ok;
        if (ok) visible++;
      }
      if (head) head.hidden = false;
      if (statusEl) {
        var terms = rules
          .map(function (r) {
            return r.q;
          })
          .join(', ');
        statusEl.textContent = statusTpl.replace(/__COUNT__/g, String(visible)).replace(/__TERMS__/g, terms);
      }
    }

    function activateTab(dir, tab) {
      var tabs = dir.querySelectorAll('[data-cos-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var tb = tabs[i];
        var on = tb === tab;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.setAttribute('tabindex', on ? '0' : '-1');
        var pid = tb.getAttribute('aria-controls');
        var panel = pid ? document.getElementById(pid) : null;
        if (panel && dir.contains(panel)) panel.hidden = !on;
      }
      if (tab) tab.focus();
    }

    function closeAllComboboxes() {
      document.querySelectorAll('[data-cos-combobox].is-open').forEach(function (box) {
        box.classList.remove('is-open');
        var list = box.querySelector('[data-cos-combobox-list]');
        var inp = box.querySelector('[data-cos-combobox-input]');
        if (list) {
          list.hidden = true;
          list.innerHTML = '';
        }
        if (inp) inp.setAttribute('aria-expanded', 'false');
      });
    }

    function initCombobox(box) {
      if (box.dataset.cosComboboxReady) return;
      box.dataset.cosComboboxReady = '1';
      var input = box.querySelector('[data-cos-combobox-input]');
      var list = box.querySelector('[data-cos-combobox-list]');
      if (!input || !list) return;
      var dir = box.closest('[data-cos-directory]');
      var dataEl = dir ? dir.querySelector('[data-cos-cities-json]') : null;
      var cities = [];
      try {
        cities = dataEl && dataEl.textContent ? JSON.parse(dataEl.textContent.trim()) : [];
      } catch (e2) {
        cities = [];
      }
      if (!Array.isArray(cities)) cities = [];
      cities.sort(function (a, b) {
        return String(a).localeCompare(String(b), undefined, { sensitivity: 'base' });
      });
      var sel = -1;

      function filterCities(q) {
        var nq = norm(String(q).trim());
        if (!nq) return cities.slice();
        var out = [];
        for (var i = 0; i < cities.length; i++) {
          if (norm(String(cities[i])).indexOf(nq) !== -1) out.push(cities[i]);
        }
        return out;
      }

      function setExpanded(on) {
        input.setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      function render() {
        var matched = filterCities(input.value);
        list.innerHTML = '';
        sel = -1;
        if (matched.length === 0) {
          list.hidden = true;
          box.classList.remove('is-open');
          setExpanded(false);
          return;
        }
        for (var j = 0; j < matched.length; j++) {
          var li = document.createElement('li');
          li.className = 'cosmetologists-combobox__option';
          li.setAttribute('role', 'option');
          li.textContent = matched[j];
          li.setAttribute('data-value', matched[j]);
          list.appendChild(li);
        }
        list.hidden = false;
        box.classList.add('is-open');
        setExpanded(true);
      }

      function close() {
        list.hidden = true;
        list.innerHTML = '';
        box.classList.remove('is-open');
        setExpanded(false);
        sel = -1;
      }

      function options() {
        return list.querySelectorAll('.cosmetologists-combobox__option');
      }

      function highlight() {
        var opts = options();
        for (var k = 0; k < opts.length; k++) {
          opts[k].setAttribute('aria-selected', k === sel ? 'true' : 'false');
        }
      }

      input.addEventListener('focus', render);
      input.addEventListener('input', render);
      input.addEventListener('keydown', function (e) {
        var opts = options();
        if (!list.hidden && opts.length) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            sel = Math.min(sel + 1, opts.length - 1);
            highlight();
            opts[sel].scrollIntoView({ block: 'nearest' });
            return;
          }
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            sel = Math.max(sel - 1, 0);
            highlight();
            opts[sel].scrollIntoView({ block: 'nearest' });
            return;
          }
          if (e.key === 'Enter' && sel >= 0) {
            e.preventDefault();
            input.value = opts[sel].getAttribute('data-value') || opts[sel].textContent || '';
            close();
            return;
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            close();
          }
        }
      });

      list.addEventListener('mousedown', function (e) {
        var li = e.target.closest('.cosmetologists-combobox__option');
        if (!li) return;
        e.preventDefault();
        input.value = li.getAttribute('data-value') || li.textContent || '';
        close();
        input.focus();
      });

      input.addEventListener('blur', function () {
        setTimeout(function () {
          if (!box.matches(':focus-within')) close();
        }, 180);
      });
    }

    function scanComboboxes(root) {
      (root || document).querySelectorAll('[data-cos-combobox]').forEach(initCombobox);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanComboboxes();
      });
    } else {
      scanComboboxes();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target && e.target.closest && e.target.closest('[id^="shopify-section-"]');
      if (sec) scanComboboxes(sec);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cos-combobox]')) return;
      closeAllComboboxes();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-cos-filter-form]')) return;
      e.preventDefault();
      var inp = form.querySelector('[data-cos-filter-input]');
      if (inp) inp.setAttribute('data-cos-applied', inp.value.trim());
      var dir = form.closest('[data-cos-directory]');
      if (dir) apply(dir);
    });

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-cos-tab]');
      if (!tab) return;
      var dir = tab.closest('[data-cos-directory]');
      if (dir) activateTab(dir, tab);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cos-shuffle]');
      if (!btn) return;
      var dir = btn.closest('[data-cos-directory]');
      if (!dir) return;
      var rules = collectRules(dir);
      if (!hasCityRule(rules)) return;
      var wrap = dir.querySelector('[data-cos-shared-results]');
      var cards = wrap ? wrap.querySelectorAll('.cosmetologist-card') : [];
      applyCitySample(dir, cards, rules, true, getVisibleCards(cards));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordions"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('image-accordions')) return;

  class ImageAccordions extends HTMLElement {
    connectedCallback() {
      this.mount = this.querySelector('[data-image-accordions-mount]');
      this.desktopTemplate = this.querySelector('[data-image-accordions-template="desktop"]');
      this.mobileTemplate = this.querySelector('[data-image-accordions-template="mobile"]');
      this.viewportQuery = window.matchMedia('(max-width: 749px)');
      this.lastIndex = this.lastIndex || '0';

      if (!this.mount || !this.desktopTemplate || !this.mobileTemplate) return;

      if (!this._onSummaryClickCapture) {
        this._onSummaryClickCapture = this.onSummaryClickCapture.bind(this);
        this.addEventListener('click', this._onSummaryClickCapture, true);
      }

      if (!this._onViewportChange) {
        this._onViewportChange = this.renderForViewport.bind(this);
      }

      if (!this._viewportListenerAttached) {
        if (this.viewportQuery.addEventListener) {
          this.viewportQuery.addEventListener('change', this._onViewportChange);
        } else if (this.viewportQuery.addListener) {
          this.viewportQuery.addListener(this._onViewportChange);
        }
        this._viewportListenerAttached = true;
      }

      this.renderForViewport();
    }

    disconnectedCallback() {
      if (!this.viewportQuery || !this._onViewportChange) return;

      if (this.viewportQuery.removeEventListener) {
        this.viewportQuery.removeEventListener('change', this._onViewportChange);
      } else if (this.viewportQuery.removeListener) {
        this.viewportQuery.removeListener(this._onViewportChange);
      }
      this._viewportListenerAttached = false;
    }

    renderForViewport() {
      var mode = this.viewportQuery.matches ? 'mobile' : 'desktop';
      if (this.currentMode === mode && this.mount.children.length) return;

      this.currentMode = mode;
      this.mount.replaceChildren(
        (mode === 'mobile' ? this.mobileTemplate : this.desktopTemplate).content.cloneNode(true)
      );
      this.bindRenderedElements();
    }

    bindRenderedElements() {
      this.tabs = Array.from(this.querySelectorAll('accordion-tab'));
      this.panels = Array.from(this.querySelectorAll('[data-image-panel]'));
      this.mobileTabBtns = Array.from(this.querySelectorAll('[data-image-accordions-mobile-tab]'));
      this.mobilePanels = Array.from(this.querySelectorAll('[data-image-accordions-mobile-panel]'));

      this._onMobileTabClick = this.onMobileTabClick.bind(this);
      this.mobileTabBtns.forEach((btn) => {
        btn.addEventListener('click', this._onMobileTabClick);
      });

      this.tabs.forEach((tab) => {
        var details = tab.querySelector('details[data-image-accordion]');
        if (!details) return;
        details.addEventListener('toggle', () => this.onDetailsToggle(details, tab));
      });

      if (!this.tabs.length) {
        this.syncMobileUi(this.lastIndex);
        return;
      }

      var selectedIndex = String(this.lastIndex);
      var selectedDetails = null;
      this.tabs.forEach(function (tab) {
        var details = tab.querySelector('details[data-image-accordion]');
        if (!details) return;
        var detailsIndex =
          details.getAttribute('data-image-accordion') ||
          (details.dataset && details.dataset.imageAccordion);
        if (detailsIndex === selectedIndex) {
          selectedDetails = details;
        }
      });

      if (selectedDetails) {
        this.tabs.forEach(function (tab) {
          var details = tab.querySelector('details[data-image-accordion]');
          if (details) details.open = details === selectedDetails;
        });
      }

      var initiallyOpen = this.tabs
        .map(function (t) {
          return t.querySelector('details[data-image-accordion]');
        })
        .find(function (d) {
          return d && d.open;
        });
      if (initiallyOpen) {
        this.lastIndex =
          initiallyOpen.getAttribute('data-image-accordion') ||
          (initiallyOpen.dataset && initiallyOpen.dataset.imageAccordion) ||
          '0';
      } else {
        var firstDetails = this.tabs[0].querySelector('details[data-image-accordion]');
        if (firstDetails) {
          firstDetails.open = true;
        }
      }

      this.syncFromState();
    }

    onMobileTabClick(e) {
      var btn = e.currentTarget;
      if (!btn || !btn.getAttribute) return;
      var idx = btn.getAttribute('data-image-accordions-mobile-tab');
      if (idx == null || idx === '') return;

      this.lastIndex = idx;
      this.syncPanels(this.lastIndex);

      var idxNum = parseInt(idx, 10);
      this.tabs.forEach(function (otherTab, i) {
        var otherDetails = otherTab.querySelector('details[data-image-accordion]');
        if (!otherDetails) return;
        if (i === idxNum) {
          otherDetails.open = true;
        } else if (otherDetails.open && typeof otherTab.shrink === 'function') {
          otherTab.shrink();
        } else {
          otherDetails.open = false;
        }
      });
    }

    syncMobileUi(index) {
      if (!this.mobileTabBtns.length) return;

      var s = String(index);
      this.mobileTabBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-image-accordions-mobile-tab') === s;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      this.mobilePanels.forEach(function (panel) {
        var on = panel.getAttribute('data-image-accordions-mobile-panel') === s;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    onSummaryClickCapture(e) {
      var tab = e.target.closest('accordion-tab');
      if (!tab || this.tabs.indexOf(tab) === -1) return;

      var summary = tab.querySelector('summary');
      if (
        !summary ||
        (e.target !== summary &&
          typeof summary.contains === 'function' &&
          !summary.contains(e.target))
      ) {
        return;
      }

      var details = tab.querySelector('details[data-image-accordion]');
      if (!details || details.open) return;

      var idx =
        details.getAttribute('data-image-accordion') ||
        (details.dataset && details.dataset.imageAccordion);
      if (idx == null || idx === '') return;

      this.lastIndex = idx;
      this.tabs.forEach(function (otherTab) {
        if (otherTab === tab) return;
        var otherDetails = otherTab.querySelector('details[data-image-accordion]');
        if (
          otherDetails &&
          otherDetails.open &&
          typeof otherTab.shrink === 'function'
        ) {
          otherTab.shrink();
        }
      });
      this.syncPanels(this.lastIndex);
    }

    onDetailsToggle(details, tab) {
      if (details.open) {
        var idx =
          details.getAttribute('data-image-accordion') ||
          (details.dataset && details.dataset.imageAccordion);
        if (idx != null && idx !== '') {
          this.lastIndex = idx;
        }
        this.tabs.forEach((otherTab) => {
          if (otherTab === tab) return;
          var otherDetails = otherTab.querySelector('details[data-image-accordion]');
          if (otherDetails && otherDetails.open && typeof otherTab.shrink === 'function') {
            otherTab.shrink();
          }
        });
        this.syncPanels(this.lastIndex);
        return;
      }

      var anyOpen = this.tabs.some(function (t) {
        var d = t.querySelector('details[data-image-accordion]');
        return d && d.open;
      });
      if (!anyOpen) {
        this.syncPanels(this.lastIndex);
      }
    }

    syncFromState() {
      var open = this.tabs
        .map(function (t) {
          return t.querySelector('details[data-image-accordion]');
        })
        .find(function (d) {
          return d && d.open;
        });
      if (open) {
        this.lastIndex =
          open.getAttribute('data-image-accordion') ||
          (open.dataset && open.dataset.imageAccordion) ||
          this.lastIndex;
      }
      this.syncPanels(this.lastIndex);
    }

    syncPanels(index) {
      this.panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.imagePanel === String(index));
      });
      this.syncMobileUi(index);
    }
  }

  customElements.define('image-accordions', ImageAccordions);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-career-path"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('school-career-path')) {
  class SchoolCareerPath extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-school-path-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-school-path-panel]'));
      this.media = Array.from(this.querySelectorAll('[data-school-path-media]'));
      this.mobileCopies = Array.from(this.querySelectorAll('[data-school-path-mobile]'));
      this.reveals = Array.from(this.querySelectorAll('[data-school-path-reveal]'));
      this.onTabPointerEnter = this.onTabPointerEnter.bind(this);
      this.onTabClick = this.onTabClick.bind(this);
      this.onTabFocus = this.onTabFocus.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      const current = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      this.dataset.active = current ? current.dataset.schoolPathTab : '';

      this.tabs.forEach((tab) => {
        tab.addEventListener('pointerenter', this.onTabPointerEnter);
        tab.addEventListener('click', this.onTabClick);
        tab.addEventListener('focus', this.onTabFocus);
      });
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('pointerenter', this.onTabPointerEnter);
        tab.removeEventListener('click', this.onTabClick);
        tab.removeEventListener('focus', this.onTabFocus);
      });
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onTabPointerEnter(event) {
      if (event.pointerType === 'touch') return;
      this.select(event.currentTarget.dataset.schoolPathTab);
    }

    onTabClick(event) {
      this.select(event.currentTarget.dataset.schoolPathTab);
    }

    onTabFocus(event) {
      this.select(event.currentTarget.dataset.schoolPathTab);
    }

    onKeydown(event) {
      const keys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      if (!event.target.closest('[data-school-path-tab]')) return;

      const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      let next = current < 0 ? 0 : current;

      if (event.key === 'ArrowDown' || event.key === 'ArrowLeft') {
        next = (next + 1) % this.tabs.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
        next = (next - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = this.tabs.length - 1;
      }

      event.preventDefault();
      this.tabs[next].focus();
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const tab = event.target.closest('[data-school-path-tab]');
      if (!tab) return;
      this.select(tab.dataset.schoolPathTab);
    }

    select(id) {
      if (!id || this.dataset.active === id) return;
      this.dataset.active = id;

      this.tabs.forEach((tab) => {
        const active = tab.dataset.schoolPathTab === id;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.schoolPathPanel === id;
        panel.classList.toggle('is-active', active);
        panel.toggleAttribute('inert', !active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.media.forEach((item) => {
        item.classList.toggle('is-active', item.dataset.schoolPathMedia === id);
      });

      this.mobileCopies.forEach((panel) => {
        const active = panel.dataset.schoolPathMobile === id;
        panel.toggleAttribute('inert', !active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.reveals.forEach((reveal) => {
        const active = reveal.dataset.schoolPathReveal === id;
        reveal.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
  }

  customElements.define('school-career-path', SchoolCareerPath);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-lead-form"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('school-lead-form')) {
  class SchoolLeadForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      const form = this.querySelector('form');
      if (!form) return;

      const trackingKeys = [
        'utm_id',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'gclid',
        'fbclid',
        'gad_source'
      ];

      try {
        const currentParams = new URLSearchParams(window.location.search);
        trackingKeys.forEach((key) => {
          const value = currentParams.get(key);
          if (value) sessionStorage.setItem(key, value);
        });
      } catch (err) {}

      const getTrackingValue = (key) => {
        try {
          return new URLSearchParams(window.location.search).get(key) || sessionStorage.getItem(key) || '';
        } catch (err) {
          return '';
        }
      };

      form.addEventListener('submit', (event) => {
        const name = form.querySelector('[name="contact[name]"]');
        const phone = form.querySelector('[name="contact[phone]"]');
        const campus = form.querySelector('[name="contact[campus]"]');
        const email = form.querySelector('[name="contact[email]"]');
        const body = form.querySelector('[data-school-lead-body]');
        const nameValue = name ? name.value.trim() : '';
        const phoneValue = phone ? phone.value.trim() : '';
        const emailValue = email ? email.value.trim() : '';
        const campusValue = campus ? campus.value : '';
        const emailSubject = (this.dataset.emailSubject || '').trim();

        if (body) {
          const lines = [];
          if (emailSubject) lines.push('נושא: ' + emailSubject);
          if (nameValue) lines.push('שם מלא: ' + nameValue);
          if (phoneValue) lines.push('טלפון: ' + phoneValue);
          if (emailValue) lines.push('אימייל: ' + emailValue);
          if (campusValue) lines.push('קמפוס: ' + campusValue);
          body.value = lines.join('\n');
        }

        const webhookUrl = (this.dataset.zapierWebhook || '').trim();
        if (!webhookUrl) return;

        if (form.dataset.webhookPending === 'true') {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        form.dataset.webhookPending = 'true';

        const gclid = getTrackingValue('gclid');
        const fbclid = getTrackingValue('fbclid');
        const gadSource = getTrackingValue('gad_source');
        let source = getTrackingValue('utm_source');

        if (!source) {
          if (gclid || gadSource) source = 'google';
          else if (fbclid) source = 'facebook';
        }

        const payload = {
          email: emailValue,
          phone: phoneValue,
          full_name: nameValue,
          campus: campusValue,
          utm_source: source,
          utm_medium: getTrackingValue('utm_medium'),
          utm_campaign: getTrackingValue('utm_campaign'),
          submitted_at: new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Jerusalem' })
        };

        if (emailSubject) payload.subject = emailSubject;

        fetch(webhookUrl, {
          method: 'POST',
          body: JSON.stringify(payload)
        })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            form.submit();
          });
      });
    }
  }

  customElements.define('school-lead-form', SchoolLeadForm);
}

if (!customElements.get('school-lead-popup')) {
  class SchoolLeadPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.panel = this.querySelector('[data-school-lead-panel]');
      if (!this.panel) return;

      this.isOpen = false;
      this.openedBy = null;
      this.mq = window.matchMedia('(max-width: 768px)');
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onMqChange = this.onMqChange.bind(this);
      this.onPopupClick = this.onPopupClick.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('click', this.onPopupClick);
      this.mq.addEventListener('change', this.onMqChange);

      if (this.isMobile() && this.querySelector('[data-school-lead-open]')) {
        this.open();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('click', this.onPopupClick);
      if (this.mq) this.mq.removeEventListener('change', this.onMqChange);
      if (this.isOpen) this.close();
    }

    isMobile() {
      return this.mq.matches;
    }

    onMqChange() {
      if (!this.isMobile() && this.isOpen) this.close();
    }

    onDocumentClick(event) {
      const link = event.target.closest('a');
      if (!link || !link.classList.contains('home-floating-button--form')) return;
      if (document.querySelector('school-lead-popup') !== this) return;

      event.preventDefault();

      if (this.isMobile()) {
        this.open(link);
        return;
      }

      this.scrollToSection();
    }

    scrollToSection() {
      const section = this.closest('.shopify-section');
      if (!section) return;

      const header = document.querySelector('.shopify-section-header, sticky-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const top = section.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    onPopupClick(event) {
      if (event.target.closest('[data-school-lead-close]')) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = this.focusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    focusableElements() {
      return Array.from(this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter((element) => !element.disabled && element.getClientRects().length > 0);
    }

    open(trigger) {
      if (!this.isMobile() || this.isOpen) return;

      this.openedBy = trigger || null;
      this.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      this.isOpen = true;
      this.addEventListener('keydown', this.onKeydown);

      const success = this.querySelector('.school-lead__success');
      const closeButton = this.querySelector('.school-lead-popup__close');
      if (success) success.focus();
      else if (closeButton) closeButton.focus();
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.classList.remove('is-open');
      this.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('overflow-hidden');

      if (this.openedBy) {
        this.openedBy.focus();
        this.openedBy = null;
      }
    }
  }

  customElements.define('school-lead-popup', SchoolLeadPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-stats"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('school-stats')) {
  class SchoolStats extends HTMLElement {
    connectedCallback() {
      if (this._played) return;
      this.watch();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    watch() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) {
        this.finish();
        return;
      }

      this._observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => {
          if (!entry.isIntersecting) return false;
          if (entry.intersectionRatio >= 0.25) return true;
          const box = entry.boundingClientRect;
          const seen = Math.min(box.bottom, window.innerHeight) - Math.max(box.top, 0);
          return seen > Math.min(window.innerHeight * 0.45, 280);
        });
        if (!visible) return;
        this._observer.disconnect();
        this.play();
      }, { threshold: [0, 0.25, 0.5] });

      this._observer.observe(this);
    }

    finish() {
      this._played = true;
      this.querySelectorAll('[data-school-stat]').forEach((item) => {
        const valueEl = item.querySelector('[data-school-stat-value]');
        if (!valueEl) return;
        valueEl.textContent = this.format(Number(item.dataset.value) || 0);
      });
    }

    play() {
      if (this._played) return;
      this._played = true;
      const duration = Number(this.dataset.duration) || 1800;
      this.querySelectorAll('[data-school-stat]').forEach((item) => {
        this.animate(item, duration);
      });
    }

    animate(item, duration) {
      const valueEl = item.querySelector('[data-school-stat-value]');
      if (!valueEl) return;
      const target = Number(item.dataset.value) || 0;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        valueEl.textContent = this.format(target * eased);
        if (progress < 1) requestAnimationFrame(step);
      };

      valueEl.textContent = '0';
      requestAnimationFrame(step);
    }

    format(value) {
      return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  customElements.define('school-stats', SchoolStats);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-story-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('school-story-videos')) {
  class SchoolStoryVideos extends HTMLElement {
    connectedCallback() {
      this.bind();
      if (this.dataset.bound === 'true') return;
      requestAnimationFrame(() => this.bind());
    }

    bind() {
      if (this.dataset.bound === 'true') return;
      const openers = this.querySelectorAll('[data-school-story-open]');
      if (!openers.length) return;
      this.dataset.bound = 'true';

      const resetMedia = (modal) => {
        const deferredMedia = modal.querySelector('deferred-media');
        if (!deferredMedia) return;

        Array.prototype.slice.call(deferredMedia.children).forEach((child) => {
          if (child.tagName === 'TEMPLATE') return;
          if (child.id && child.id.indexOf('Deferred-Poster-') === 0) return;
          child.remove();
        });
        deferredMedia.removeAttribute('loaded');
      };

      const loadMedia = (modal) => {
        window.setTimeout(() => {
          if (!modal.hasAttribute('open')) return;
          const deferredMedia = modal.querySelector('deferred-media');
          if (
            deferredMedia &&
            !deferredMedia.hasAttribute('loaded') &&
            !deferredMedia.querySelector('video, iframe')
          ) {
            deferredMedia.loadContent(false);
          }
        }, 100);
      };

      openers.forEach((opener) => {
        const button = opener.querySelector('button');
        const modal = this.querySelector(opener.getAttribute('data-modal'));
        if (!button || !modal) return;

        button.addEventListener('click', () => loadMedia(modal));

        if (modal.dataset.bound === 'true') return;
        modal.dataset.bound = 'true';

        const observer = new MutationObserver(() => {
          if (!modal.hasAttribute('open')) resetMedia(modal);
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
      });
    }
  }

  customElements.define('school-story-videos', SchoolStoryVideos);
}

  } catch(e) { console.error(e); }
})();
})();
